import { render } from "./DesEnfermedades.vue?vue&type=template&id=58a2fcdd&scoped=true"
import script from "./DesEnfermedades.vue?vue&type=script&lang=js"
export * from "./DesEnfermedades.vue?vue&type=script&lang=js"

import "./DesEnfermedades.vue?vue&type=style&index=0&id=58a2fcdd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58a2fcdd"]])

export default __exports__